import {
	CLEAR_GIFT_BUCKETS,
	CLEAR_GIFT_BUCKET_UPDATE_ERRORS,
	CLEAR_GIFT_BUCKET_CREATE_ERRORS,
	FETCH_GIFT_BUCKETS_SUCCEEDED,
	UPDATE_GIFT_BUCKET,
	UPDATE_GIFT_BUCKET_FAILED,
	UPDATE_GIFT_BUCKET_SUCCEEDED,
	CREATE_GIFT_BUCKET,
	CREATE_GIFT_BUCKET_FAILED,
	CREATE_GIFT_BUCKET_SUCCEEDED,
	DELETE_GIFT_BUCKET,
	DELETE_GIFT_BUCKET_FAILED,
	DELETE_GIFT_BUCKET_SUCCEEDED,
} from './giftBucket.action';
import { giftBucketsInitialState } from './giftBucket.initialState';
import { clone, path, pathOr, dissoc } from 'ramda';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const giftBucketReducer = (state = giftBucketsInitialState, action) => {
	switch (action.type) {
		case CLEAR_GIFT_BUCKETS: {
			return {
				...state,
				...giftBucketsInitialState,
			};
		}

		case CLEAR_GIFT_BUCKET_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_GIFT_BUCKET_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case FETCH_GIFT_BUCKETS_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			return {
				...state,
				entities,
				pendingFetch: false,
			};
		}

		case UPDATE_GIFT_BUCKET: {
			return createPendingState(state, 'pendingUpdate');
		}

		case UPDATE_GIFT_BUCKET_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case UPDATE_GIFT_BUCKET_SUCCEEDED: {
			const updatedGiftBucketId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedGiftBucketId) {
				newState.entities = {
					...state.entities,
					[updatedGiftBucketId]: action.payload,
				};
			}

			return newState;
		}

		case CREATE_GIFT_BUCKET: {
			return createPendingState(state, 'pendingCreate');
		}

		case CREATE_GIFT_BUCKET_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case CREATE_GIFT_BUCKET_SUCCEEDED: {
			const createdGiftBucketId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingCreate: false,
			};

			if (createdGiftBucketId) {
				newState.entities = {
					...state.entities,
					[createdGiftBucketId]: action.payload,
				};
			}

			return newState;
		}

		case DELETE_GIFT_BUCKET: {
			return createPendingState(state, 'pendingDelete');
		}

		case DELETE_GIFT_BUCKET_FAILED: {
			return createErrorState(state, 'pendingDelete', 'deleteError', action.payload);
		}

		case DELETE_GIFT_BUCKET_SUCCEEDED: {
			const deletedGiftBucketId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingDelete: false,
			};

			if (deletedGiftBucketId) {
				newState.entities = dissoc(deletedGiftBucketId, state.entities);
			}

			return newState;
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/giftBuckets/giftBucket.reducer.js